import { render } from "./LichenGallery.vue?vue&type=template&id=a82604bc"
import script from "./LichenGallery.vue?vue&type=script&lang=js"
export * from "./LichenGallery.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__